import api from '../../services/api';
import { OPERATOR_REQUEST_CONFIG, warehousePath } from '../operator/operatorApi';

/** Pending and partial receipts, oldest first. */
export const getReceiptsRequest = (warehouseId, { page = 1, search = '' } = {}) =>
  api.get(warehousePath(warehouseId, 'receipts/'), {
    ...OPERATOR_REQUEST_CONFIG,
    params: { page, ...(search ? { search } : {}) },
  });

/** A receipt with its lines, their codes and the receiving slots. */
export const getReceiptRequest = (warehouseId, receiptId) =>
  api.get(warehousePath(warehouseId, `receipts/${receiptId}/`), OPERATOR_REQUEST_CONFIG);

/**
 * Counts what arrived. Answers with the whole receipt, updated. Over what a
 * line lacks, only with `confirm_excess`: without it, 409 `over_receipt`.
 *
 * @param {object} body - `{scans: [{code, line_id, quantity, lot?, expiry_date?}], slot_code?, confirm_excess?,
 *   idempotency_key}`
 */
export const countReceiptRequest = (warehouseId, receiptId, body) =>
  api.post(warehousePath(warehouseId, `receipts/${receiptId}/count/`), body, OPERATOR_REQUEST_CONFIG);

/** Closes it; short of what was expected only with `confirm_shortage`. */
export const closeReceiptRequest = (warehouseId, receiptId, body) =>
  api.post(warehousePath(warehouseId, `receipts/${receiptId}/close/`), body, OPERATOR_REQUEST_CONFIG);
